import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

type AdminMfaQrProps = {
  otpauthUri: string
}

export default function AdminMfaQr({ otpauthUri }: AdminMfaQrProps) {
  const [dataUrl, setDataUrl] = useState('')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let active = true
    setDataUrl('')
    setFailed(false)

    void QRCode.toDataURL(otpauthUri, {
      errorCorrectionLevel: 'M',
      margin: 3,
      width: 384,
      color: {
        dark: '#0D0D0D',
        light: '#FFF9F4',
      },
    }).then((url) => {
      if (active) setDataUrl(url)
    }).catch(() => {
      if (active) setFailed(true)
    })

    return () => {
      active = false
    }
  }, [otpauthUri])

  return (
    <div className="admin-enrollment-qr">
      <div className="admin-enrollment-qr__frame">
        {dataUrl ? (
          <img src={dataUrl} alt="Authenticator setup QR code" />
        ) : (
          <div className="admin-enrollment-qr__loading" role="status">
            {failed ? 'QR code unavailable. Use the manual setup key below.' : 'Preparing QR code…'}
          </div>
        )}
      </div>
      <p className="admin-enrollment-qr__caption">
        Scan with your authenticator app. The setup key below remains available as a fallback.
      </p>
    </div>
  )
}
